/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Start_LabelInputs */

const th_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่ม`)
};

const en_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts`)
};

const ja_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

const zh_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始`)
};

const es_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza`)
};

const pt_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa`)
};

const id_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai`)
};

const fr_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début`)
};

const tl_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagsisimula`)
};

const vi_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu`)
};

const ko_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작`)
};

const de_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnt`)
};

const ru_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинается`)
};

const tr_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç`)
};

const it_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio`)
};

const pl_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Początek`)
};

const uk_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Початок`)
};

const hi_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आरंभ`)
};

const ar_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبدأ`)
};

const ms_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mula`)
};

const bn_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরু`)
};

const zh_tw2_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

const zh_hk2_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

const ur_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آغاز`)
};

const fa_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آغاز`)
};

const sw_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linaanza`)
};

const nl_event_start_label = /** @type {(inputs: Event_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begint`)
};

/**
* | output |
* | --- |
* | "Starts" |
*
* @param {Event_Start_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_start_label = /** @type {((inputs?: Event_Start_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Start_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_start_label(inputs)
	if (locale === "ja") return ja_event_start_label(inputs)
	if (locale === "zh") return zh_event_start_label(inputs)
	if (locale === "es") return es_event_start_label(inputs)
	if (locale === "pt") return pt_event_start_label(inputs)
	if (locale === "id") return id_event_start_label(inputs)
	if (locale === "fr") return fr_event_start_label(inputs)
	if (locale === "tl") return tl_event_start_label(inputs)
	if (locale === "vi") return vi_event_start_label(inputs)
	if (locale === "ko") return ko_event_start_label(inputs)
	if (locale === "de") return de_event_start_label(inputs)
	if (locale === "ru") return ru_event_start_label(inputs)
	if (locale === "tr") return tr_event_start_label(inputs)
	if (locale === "it") return it_event_start_label(inputs)
	if (locale === "pl") return pl_event_start_label(inputs)
	if (locale === "uk") return uk_event_start_label(inputs)
	if (locale === "hi") return hi_event_start_label(inputs)
	if (locale === "ar") return ar_event_start_label(inputs)
	if (locale === "ms") return ms_event_start_label(inputs)
	if (locale === "bn") return bn_event_start_label(inputs)
	if (locale === "zh-TW") return zh_tw2_event_start_label(inputs)
	if (locale === "zh-HK") return zh_hk2_event_start_label(inputs)
	if (locale === "ur") return ur_event_start_label(inputs)
	if (locale === "fa") return fa_event_start_label(inputs)
	if (locale === "sw") return sw_event_start_label(inputs)
	if (locale === "nl") return nl_event_start_label(inputs)
	return en_event_start_label(inputs)
});